import { ElementRef, Injectable } from "@angular/core";
import _cloneDeep from "lodash/cloneDeep";
import _unescape from "lodash/unescape";

import { ConfigurationError } from "./errors/configuration.error";

@Injectable()
export class ConfigurationService<TConfig> {
    private readonly DEFAULT_DATA_ATTRIBUTE_NAME = "config";

    private _config: TConfig = null;

    public get config(): TConfig {
        return _cloneDeep(this._config);
    }

    public initialize(domElement: ElementRef, domAttribute: string = this.DEFAULT_DATA_ATTRIBUTE_NAME): void {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const json = domElement.nativeElement.dataset[domAttribute] as string;

        if (!json) {
            throw new ConfigurationError(`Mandatory 'data-${domAttribute}' attribute is not set or empty.`);
        }

        this._config = JSON.parse(_unescape(json)) as TConfig;
    }
}
